import {requestRemoteData} from "../../../API/api";

const RELATED_PRODUCTS_ENDPOINT = 'products/related';
const CATALOG_ENDPOINT = 'products';
const FAVORITES_ENDPOINT = 'account/favorites';
const TRACKED_PRODUCTS_ENDPOINT = 'account/products/tracked';

export const fetchRelatedProducts = (productCode, { page, amount }) => {
  return requestRemoteData(
    RELATED_PRODUCTS_ENDPOINT,
    {
        method: 'POST',
        body: {
            productCode: productCode,
            pagination: {
                page: page,
                size: amount
            }
        },
        headers: {'X-Api-Version': '2'}
    }
  );
};

export const fetchAllBis = (filters, config) => {
    return requestRemoteData(
        CATALOG_ENDPOINT,
        {
            method: 'POST',
            body: {
                filter: {
                    taxonomy: {
                        macrofamilyIds: filters?.taxonomyTree?.macrofamilyId ? [filters.taxonomyTree?.macrofamilyId] : null,
                        familyIds: filters?.taxonomyTree?.familyId ? [filters?.taxonomyTree?.familyId] : null,
                        subfamilyIds: filters?.taxonomyTree?.subfamilyIds ? Array.from(filters?.taxonomyTree?.subfamilyIds) : null,
                    },
                    search: filters?.search,
                    species: filters?.species ? Array.from(filters.species) : null,
                    manufacturerIds: filters?.manufacturerIds ? Array.from(filters?.manufacturerIds) : null,
                    characteristics: {
                        featured: filters?.characteristics?.featured,
                        prescription: filters?.characteristics?.prescription
                    }
                },
                pagination: {
                    page: config.page,
                    size: config.amount
                }
            }
        }
    );
};

export const fetchFavorites = () => {
  return requestRemoteData(
    FAVORITES_ENDPOINT,
    { headers: { 'X-Api-Version': '2' } }
  );
};


/**
 * @returns {Promise<RemoteData<Product[]>>}
 */
export const fetchTracked = () => {
  return requestRemoteData(TRACKED_PRODUCTS_ENDPOINT);
};
